import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import {
  Grid2 as Grid,
  Divider as MuiDivider,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing } from "@mui/system";
import { green, red } from "@mui/material/colors";

import Stats from "./Stats";
import useAuth from "@/hooks/useAuth";
import { useUsersRequest } from "apiRequests/users";

const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

function Default() {
  const { t } = useTranslation();
  const { user } = useAuth(); 

  let { data } = useUsersRequest(user)
  
  if (typeof data === "string") {
    console.log("Data is a string:", data)
    data = undefined
  }

  const activeUsers = data?.filter((user) => 
    user.isLocked == false
    && (!!user?.isReady || (!!user?.answer?.data?.survey?.personalInformation && !!user?.answer?.data?.survey?.academics))
  ) ?? []


  const percentageActive = activeUsers.length / (data?.length ?? 0 - activeUsers.length) * 100
  

  const lockedUsers = data?.filter((user) => user.isLocked) ?? []
  const lockedPercentage = (lockedUsers?.length ?? 0) / (data?.length ?? 0 - lockedUsers.length) * 100
  const usersReady = data?.filter((user) => user.isReady) ?? []
  const readyPercentage = (usersReady?.length ?? 0) / (data?.length ?? 0 - usersReady.length) * 100

  const usersInvited = data?.filter((user) => 
    user.isLocked == false
    && (!user?.isReady && (!user?.answer?.data?.survey?.personalInformation && !user?.answer?.data?.survey?.academics))
  ) ?? []

  const invitedPercentage = (usersInvited?.length ?? 0) / (data?.length ?? 0 - usersInvited.length) * 100

  return (
    <React.Fragment>
      <Helmet title="Default Dashboard" />
      <Grid justifyContent="space-between" container spacing={6}>
        <Grid>
          <Typography variant="subtitle1">
            {t("Welcome back")}, {user?.answer?.data?.survey?.personalInformation?.firstName ?? user?.email}!
          </Typography>
        </Grid>

        {/* <Grid>
          <Actions />
        </Grid> */}
      </Grid>
      <Divider my={6} />
      <Grid container spacing={6}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 6,
            lg: 3,
            xl: "grow",
          }}
        >
          <Stats
            title="Active Users"
            amount={(activeUsers?.length ?? 0).toString()}
            chip="Total"
            percentagetext={`${percentageActive.toString()}%`}
            percentagecolor={green[500]}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 6,
            lg: 3,
            xl: "grow",
          }}
        >
          <Stats
            title="Blocked Users"
            amount={(lockedUsers?.length ?? 0).toString()}
            chip="Total"
            percentagetext={`${lockedPercentage}%`}
            percentagecolor={red[500]}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 6,
            lg: 3,
            xl: "grow",
          }}
        >
          <Stats
            title="Ready Users"
            amount={(usersReady?.length ?? 0).toString()}
            chip="Total"
            percentagetext={`${readyPercentage}%`}
            percentagecolor={green[500]}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 6,
            lg: 3,
            xl: "grow",
          }}
        >
          <Stats
            title="Invited Users"
            amount={usersInvited?.length.toString()}
            chip="Total"
            percentagetext={`${invitedPercentage}%`}
            percentagecolor={green[500]}
            illustration="/static/img/illustrations/waiting.png"
          />
        </Grid>
      </Grid>
      {/* <Grid container spacing={6}>
        <Grid
          size={{
            xs: 12,
            lg: 8,
          }}
        >
          <LineChart />
        </Grid>
        <Grid
          size={{
            xs: 12,
            lg: 4,
          }}
        >
          <DoughnutChart />
        </Grid>
      </Grid>
      <Grid container spacing={6}>
        <Grid
          size={{
            xs: 12,
            lg: 4,
          }}
        >
          <BarChart />
        </Grid>
        <Grid
          size={{
            xs: 12,
            lg: 8,
          }}
        >
          <Table />
        </Grid>
      </Grid> */}
    </React.Fragment>
  );
}

export default Default;
